import React from 'react';

import { LabelMedium } from '@ui-library/typography';
import theme from '@css/theme';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';

interface IErrorProps {
  error: boolean;
  errorMessage: string;
  width?: string;
  height?: string;
  background?: string;
  padding?: string;
  color?: string;
  showIcon?: boolean;
}

const ErrorIcon = styled.div`
  margin-right: 10px;
  float: left;
  color: ${theme.color.error};
`;

const ErrorLabel = ({
  error,
  errorMessage,
  height,
  width,
  background,
  padding,
  showIcon = true,
  color = theme.color.error,
}: IErrorProps) => {
  if (errorMessage.length > 0 && error) {
    return (
      <div
        style={{ background, padding, height, maxWidth: width }}
        className="m-v-sm"
        data-testid="error-label"
      >
        {showIcon && (
          <ErrorIcon>
            <FontAwesomeIcon icon={regular('circle-exclamation')} />
          </ErrorIcon>
        )}
        <LabelMedium color={color}>{errorMessage}</LabelMedium>
      </div>
    );
  }

  return <div />;
};

export default ErrorLabel;
